// import React from "react";
// import DepartmentHead from "./TableHead/DepartmentHead";
// import DepartmentBody from "./TableBody/DepartmentBody";

// const DepartmentTable = ({
//   permissionsAccessControl,
//   departments,
//   handleOpenPopup,
//   handleDelete,
//   status,
// }) => {
//   return (
//     <div className="row" style={{ marginTop: "10px" }}>
//       <div className="col-12">
//         <div className="card">
//           <div className="card__body">
//             <div className="table-wrapper">
//               <table style={{ overflow: "hidden" }}>
//                 <DepartmentHead
//                   permissionsAccessControl={permissionsAccessControl}
//                   status={status}
//                 />
//                 <DepartmentBody
//                   departments={departments}
//                   handleOpenPopup={handleOpenPopup}
//                   handleDelete={handleDelete}
//                   status={status}
//                 />
//               </table>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

import React from "react";
import ReusableDataTable from "src/components/table/ReusableDataTable";
import GetDepartmentTableColumns from "./ColumnDefinition/DepartmentColumn/GetDepartmentTableColumns";
import { mapDepartmentToDataTable as mapData } from "./Helper";

const DepartmentTable = ({ data, handleDelete, handleOpenPopup, status }) => {
  const columns = GetDepartmentTableColumns({
    handleOpenPopup,
    handleDelete,
    status,
  });

  return (
    <ReusableDataTable columns={columns} data={mapData(data)} maxHeight={500} />
  );
};

export default DepartmentTable;
